import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody } from 'reactstrap';

import {
    ZoneEditor,
    CheckpointCreator
} from 'components/features';
import {
    ZoneTable
} from 'components/blocks'

const Zone = ({ dispatch, zones, zone, zoneList }) => {
    const { byid, list, ..._zone } = zone

    let zoneSection = _zone.section
    let zoneTelegram = _zone.telegramId

    const zoneStyle = {
        backgroundColor: _zone.color,
    }

    return (
        <React.Fragment>
            <Row className="mb-2">
                <Col xs="12" sm="6">
                    <Row>
                        <div className="ml-4 pt-1 text-right">
                            <div className="sm-box h-100 ml-auto" style={zoneStyle}></div>
                        </div>
                        <Col xs="8" className="text-left">
                            <div className="font-2xl display-4 text-muted">Zone: {zoneSection}</div>
                            <small className="text-muted">Telegram ID: {zoneTelegram}</small>
                        </Col>
                    </Row>
                </Col>
                <Col xs="12" sm="6" className="text-right mt-2 mt-sm-0 pt-2 pr-4">
                    <ZoneEditor
                        zone={zone}
                    />
                </Col>
            </Row>
            <Card>
                <CardBody>
                    <CheckpointCreator zoneId={zone.id} />
                </CardBody>
            </Card>
            <Card>
                <CardBody style={{ overflow: 'auto' }}>
                    <ZoneTable dispatch={dispatch} items={byid} itemList={list} zones={zones} zone={zone} zoneList={zoneList} />
                </CardBody>
            </Card>
        </React.Fragment>

    )
};

Zone.propTypes = {
    zone: PropTypes.object,
    zones: PropTypes.object,
    dispatch: PropTypes.func,
    zoneList: PropTypes.array
};

export default Zone;



// WEBPACK FOOTER //
// ./src/components/sections/Zone/Zone.js